import { ClaimRow } from 'api/endpoints';
import { ExhibitFields } from '../typesExhibitExporter';

export interface ExhibitTemplateProps {
  exhibit: ExhibitFields;
  claimItems: ClaimRow[];
  primaryCaseNumber: string | undefined;
  projectName: string | undefined;
  actionName: string | undefined;
}

export enum ExhibitTemplates {
  AllowedClaims = 'AllowedClaims',
  AlterClaimAmount = 'AlterClaimAmount',
  AlterClaimAmountProposeDebtor = 'AlterClaimAmountProposeDebtor',
  AlterDebtor = 'AlterDebtor',
  ExpungeNoSurviving = 'ExpungeNoSurviving',
  ExpungeWithSurviving = 'ExpungeWithSurviving',
}

export const getTemplateName = (
  substatusId: number | undefined,
): ExhibitTemplates | undefined => {
  switch (substatusId) {
    case ACTION_SUBSTATUS['Amended & Replaced Claims']:
    case ACTION_SUBSTATUS['Duplicative Claims']:
    case ACTION_SUBSTATUS['Redundant Claims']:
    case ACTION_SUBSTATUS['Beneficial Bondholder Claims']:
      return ExhibitTemplates.ExpungeWithSurviving;
    case ACTION_SUBSTATUS['Satisfied During the Case Claims']:
    case ACTION_SUBSTATUS['No Basis Claims']:
    case ACTION_SUBSTATUS['No Liability Claims']:
    case ACTION_SUBSTATUS['No Support Claims']:
    case ACTION_SUBSTATUS['Non-Debtor']:
    case ACTION_SUBSTATUS['Post-Petition']:
    case ACTION_SUBSTATUS['Late Filed Claims']:
    case ACTION_SUBSTATUS['Equity Interest Claims']:
    case ACTION_SUBSTATUS['Contract Assumed & Assigned Claims']:
    case ACTION_SUBSTATUS['Anticipatory Contract Rejection Claims']:
      return ExhibitTemplates.ExpungeNoSurviving;
    case ACTION_SUBSTATUS['Wrong Debtor Claims']:
      return ExhibitTemplates.AlterDebtor;
    case ACTION_SUBSTATUS['Reduce Claims']:
    case ACTION_SUBSTATUS['Misclassified Claims']:
    case ACTION_SUBSTATUS['Reduce & Reclass Claims']:
    case ACTION_SUBSTATUS['Modify Claims']:
      return ExhibitTemplates.AlterClaimAmount;
    case ACTION_SUBSTATUS['Wrong Debtor Reduce Claims']:
    case ACTION_SUBSTATUS['Wrong Debtor Misclassified Claims']:
    case ACTION_SUBSTATUS['Wrong Debtor Reduce & Reclass Claims']:
      return ExhibitTemplates.AlterClaimAmountProposeDebtor;
    case ACTION_SUBSTATUS['Allowed Claims']:
      return ExhibitTemplates.AllowedClaims;
    default:
      return undefined;
  }
};

const ACTION_SUBSTATUS = {
  'Amended & Replaced Claims': 1,
  'Duplicative Claims': 2,
  'Redundant Claims': 3,

  'Satisfied During the Case Claims': 4,
  'No Basis Claims': 5,
  'No Liability Claims': 6,
  'No Support Claims': 7,
  'Non-Debtor': 30,
  'Post-Petition': 31,
  'Late Filed Claims': 8,
  'Equity Interest Claims': 9,
  'Contract Assumed & Assigned Claims': 10,
  'Anticipatory Contract Rejection Claims': 11,
  'Beneficial Bondholder Claims': 12,

  'Void Claims': 13,
  'Withdrawn Claims': 14,
  'Anticipated Withdrawal': 15,
  'Allowed Claims': 16,
  'Agreement Stipulation Expunge': 17,
  'Proposed Settlement': 18,
  'Settlement Sent for Signature': 19,
  'Agreement Stipulation Alter': 20,

  'Wrong Debtor Claims': 21,

  'Reduce Claims': 22,
  'Misclassified Claims': 23,
  'Reduce & Reclass Claims': 24,
  'Wrong Debtor Reduce Claims': 25,
  'Wrong Debtor Misclassified Claims': 26,
  'Wrong Debtor Reduce & Reclass Claims': 27,
  'Modify Claims': 28,
  'Wrong Debtor Modify Claims': 29,
} as const;
